export default {
  init() {

    // JavaScript to be fired on all pages
    var is_mm = false;
    const bodyScrollLock = require('body-scroll-lock');
    const disableBodyScroll = bodyScrollLock.disableBodyScroll;
    const enableBodyScroll = bodyScrollLock.enableBodyScroll;
    
    var showMM = function() {
      disableBodyScroll(document.querySelector('#nav-primary'));
      jQuery('header nav').show();
      jQuery('.mm-mob').hide();
    }

    var hideMM = function() {
      enableBodyScroll(document.querySelector('#nav-primary'));
      jQuery('header nav').hide();
    }
    
    var resize = function() {
      if($( window ).width() < 1024) {
        is_mm = true;
      } else {
        is_mm = false;
        showMM();
      }
    }

    jQuery(function( $ ) {
      resize();
      $( window ).on('resize', resize);
      $('.mm-open').on('click', function() {
        jQuery('.sub-menu').hide();
        showMM();
      });
      $('.mm-close').on('click', function() {
        hideMM();
      });
      $('.mm-go-back').on('click', function() {
        $(this).parent().parent().hide();
      });
      $('header nav a').on('click', function(e) {
        if(is_mm) {
          // handle clicks for mobile menu
          if($(this).parent().has('.mm-mob').length) {
            e.preventDefault();
            $(this).parent().find('.mm-mob').show();
            return;
          }
          if($(this).parent().has('ul.sub-menu').length) {
            e.preventDefault();
            $(this).parent().find('ul.sub-menu').show();
            return;
          }
          
        }
      });

      $('.ac-trigger').click(function() {
        $(this).parent().parent().find('.ac-panel').slideToggle();
        $(this).parent().parent().find('.ac-trigger i.ac-icon').toggleClass('icon-plus-circled icon-minus-circled');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js